export default __webpack_public_path__ + "static/odoo-123e7ec2a0fa2f90d03aa41ce5a1744f.svg";